import React, { useEffect } from "react"
import { useRenderStyling } from "lib/hooks/useRenderStyling"
import { parseContent, parseContentGroup } from "./utils"

export default function LogoAreaRender({ renderPkg }:{ renderPkg?:any }){

  const logoStyle = useRenderStyling("flex justify-end mt-3 w-full mb-4 ml-10", "styleObj")

  const settings = renderPkg.dispute.elements.find((setting:any) => setting.refstr === "mm_logo").settings || {}

  return (
    <div id="mm-logo" {...logoStyle}>
      <img src={settings?.src} alt="Logo" className="w-full h-auto" />
    </div>
  )
}